<template>
  <div
    :class="isIndex == '1' ? 'indexnav2' : 'indexnav'"
    v-if="$conFun.clientWidth() > 768"
  >
    <div class="pageWD navflex">
      <div class="logo">
        <img
          src="../assets/images/1/logo_blue.png"
          style="width: 144px; height: 45px"
          v-if="isIndex == '1'"
        />
        <img
          src="../assets/images/1/logo.png"
          style="width: 144px; height: 45px"
          v-else
        />
      </div>

      <div class="nav">

        <span :class="isActive == '1' ? 'current' : ''" @click="tapMe('/')"
          >首页</span
        >
        <!-- <span
          :class="isActive == '2' || isMe == '2' ? 'current' : ''"
          @click="tapMe('/kcsz')"
          >课程师资</span
        >
        <span
          :class="isActive == '3' || isMe == '3' ? 'current' : ''"
          @click="tapMe('/alfx')"
          >案例分析</span
        >
        <span :class="isActive == '4' ? 'current' : ''" @click="tapMe('/szfw')"
          >数智服务</span
        > -->
        <span :class="isActive == '5' ? 'current' : ''" @click="tapMe('/bmtd')"
          >报名通道</span
        >
        <span :class="isActive == '6' ? 'current' : ''" @click="tapMe('/news')"
          >云学资讯</span
        >
        <span :class="isActive == '7' ? 'current' : ''" @click="tapMe('/about')"
          >关于云学</span
        >
      </div>
    </div>
  </div>
  <div v-else>
    <div class="momask"  v-if="isShow" @click="toggleMeNav"></div>
    <div class="navfixed flex-sb" style="padding:12px;border-bottom:1px solid #DDDDDD">
      <div >
          <img src="../assets/images/1/logo.png" style=" width:78px; height:25px" />
      </div>
      <div><i :class="isShow?'el-icon-close':'el-icon-s-fold'" style="font-size:28px;color:#ccc;margin:0 12px 0 0" @click="toggleMeNav"></i></div>
    </div>
    <div class="mbnav" v-if="isShow">
        <div class="mb1" @click="tapMe('/')" >首页</div>
        <div class="mb1"  @click="tapMe('/bmtd')">报名通道</div>  
        <div class="mb1" @click="tapMe('/news')">云学资讯</div>
        <div class="mb1" @click="tapMe('/about')">关于云学</div>         
    </div> 
  </div>
</template>
<script>
export default {
  name: "Nav",
  props: ["isActive", "isIndex"],
  data() {
    return {
      showMe: "",
      isMe: "",
      isShow: false,
    };
  },

  mounted() {},
  methods: {
    tapMe(add) {
      this.$router.push({ path: add });
    },
    toggleMeNav() {
      this.isShow = !this.isShow;
    },
    mouseoverMe(index) {
      this.isMe = index;
      this.showMe = index;
    },
    mouseoutMe(e) {
      this.isMe = "";
      this.showMe = "";
    }
  }
};
</script>
<style scoped>
.nav {
 
  text-align: left;
}
.logo{
  margin-right: 40px;
  padding-top:13px
}
.nav .el-menu.el-menu--horizontal {
  border: 0;
}
.nav span {
  display: inline-block;
  font-size: 18px;
  color: #fff;
  text-align: center;
  padding:0 15px;
  margin: 0 50px;
  cursor: pointer;
}

.indexnav {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 100;
   background: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(15, 81, 117, 0.2);
  width: 100%;
  color: #fff;
  height: 75px;
  font-size: 18px;
}

.indexnav .nav span {
  color: #333;
  font-size: 18px;
}
.indexnav .nav span:hover {
  color: #333;
  font-size: 18px;
}
.indexnav2 {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 100;
  /* background: url("../assets/images/1/home_tab_background.png") repeat-x; */
  width: 100%;
  color: #999999;
  height: 75px;
  font-size: 18px;
}
.indexnav2 .nav span:hover,
.indexnav2 .nav .current,
.indexnav2 .nav span.is-actived {
  border-bottom:2px solid #fff;
  padding: 13px 15px;
}
.indexnav2 .nav span {
  color: #fff;
  font-size: 18px;
}
.indexnav2 .nav span.current {
  color: #fff;
}
.indexnav2 .nav span:hover {
  color: #fff;
  font-size: 18px;
}
.navflex {
  display: flex;
  align-items: center;
}
.indexnav .nav span:hover,
.indexnav .nav .current,
.indexnav .nav span.is-actived {
  border-bottom:2px solid #25A2DD;
  color:#25A2DD;
  padding: 13px 15px;
}
.navall {
  height: 85px;
  background: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(15, 81, 117, 0.2);
}
.navfixed {
  position: fixed;
  height: 54px;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 99999999;
}
.mbnav {
  position: fixed;
  right: 0;
  top: 54px;
  z-index: 999;
  background: #fff;
  width: 145px;
}
.mbnav .mb1 {
  font-size: 18px;
  color: #333;
  padding: 12px 20px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.mbnav .mb2 {
  font-size: 15px;
  color: #666;
  background: #f5f5f5;
  padding: 12px 0 12px 32px;
  border-bottom: 1px solid #ddd;
}
</style>





// WEBPACK FOOTER //
// src/components/Nav.vue